import { useState, useEffect } from "react";
import { getEntityTypesWithCache } from "../utils/entityTypeUtils";

/**
 * Hook to get entity types with caching
 */
export function useEntityTypes() {
  const [entityTypes, setEntityTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEntityTypes = async () => {
      try {
        setLoading(true);
        const types = await getEntityTypesWithCache();
        setEntityTypes(types);
        setError(null);
      } catch (err) {
        setError(err);
        setEntityTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEntityTypes();
  }, []);

  return { entityTypes, loading, error };
}

